import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    getRecurringTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringTransactions`,
        params: {
            '$count': true
        }
    },
    deleteRecurringTransaction: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/recurringTransactions/:transactionId`
    },
    saveRecurringCredits: {
        method: 'POST',
        url: `${BASE_PATH_API}/RecurringCredits`
    },
    saveRecurringPayments: {
        method: 'POST',
        url: `${BASE_PATH_API}/RecurringPayments`
    },
    getRecurringCheck: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringChecks/:id`
    },
    createRecurringCheck: {
        method: 'POST',
        url: `${BASE_PATH_API}/recurringChecks`
    },
    updateRecurringCheck: {
        method: 'PUT',
        url: `${BASE_PATH_API}/recurringChecks/:id`
    },
    getRecurringBill: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringBills/:id`
    },
    createRecurringBill: {
        method: 'POST',
        url: `${BASE_PATH_API}/recurringBills`
    },
    updateRecurringBill: {
        method: 'PUT',
        url: `${BASE_PATH_API}/recurringBills`
    },

    createRecurringGeneralJournalEntries: {
        method: 'POST',
        url: `${BASE_PATH_API}/recurringGeneralJournalEntries`
    },

    getRecurringGeneralJournalEntries: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringGeneralJournalEntries/:id`
    },

    updateRecurringGeneralJournalEntries: {
        method: 'PUT',
        url: `${BASE_PATH_API}/recurringGeneralJournalEntries`
    },
    
    getRecurringCredits: {
        method: 'GET',
        url: `${BASE_PATH_API}/RecurringCredits/:id`
    },
    updateRecurringCredits: {
        method: 'PUT',
        url: `${BASE_PATH_API}/RecurringCredits/:id`
    },
    getRecurringPayment: {
        method: 'GET',
        url: `${BASE_PATH_API}/RecurringPayments/:id`
    },
    updateRecurringPayment: {
        method: 'PUT',
        url: `${BASE_PATH_API}/RecurringPayments/:id`
    },
    getAllBooksUserCanAccess: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringTransactions/booksUserCanAccess`
    }
};

export function RecurringTransactionsApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getRecurringTransactionsExportUrl = function getRecurringTransactionsExportUrl(params) {
        return `${BASE_PATH_API}/recurringTransactions/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
RecurringTransactionsApi.$inject = [
    '$httpParamSerializer'
];
